import { render, staticRenderFns } from "./AllocationMonth.vue?vue&type=template&id=9716f3c8&scoped=true&"
import script from "./AllocationMonth.vue?vue&type=script&lang=js&"
export * from "./AllocationMonth.vue?vue&type=script&lang=js&"
import style0 from "./AllocationMonth.vue?vue&type=style&index=0&id=9716f3c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9716f3c8",
  null
  
)

export default component.exports